import { useTranslation } from 'hooks/useTranslation';
import { useDailyOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/store/dailyOvertimeDashboard.store';
import { KpiStatCardProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';
import {
  buildClearedCard,
  buildErrorCard,
  buildValueCard,
} from 'pages/ReportsPage/components/AnalyticsDashboards/kpiCardBuilders';
import { formatPayPeriodRangeLabel } from 'pages/ReportsPage/components/AnalyticsDashboards/payPeriodFormatters';
import { isSelectionCleared } from 'pages/ReportsPage/store/analyticsSelection.utils';
import { useAnalyticsFilterStore } from 'pages/ReportsPage/store/analyticsFilterView.context';

export function useDailyOvertimeKpiCards(): KpiStatCardProps[] {
  const locationIds = useAnalyticsFilterStore((s) => s.locationIds);
  const positions = useAnalyticsFilterStore((s) => s.positions);
  const { i18n } = useTranslation();
  const totalOtHours = useDailyOvertimeDashboardStore((s) => s.totalOtHours);
  const totalOtHoursChangePrct = useDailyOvertimeDashboardStore((s) => s.totalOtHoursChangePrct);
  const totalOtHoursError = useDailyOvertimeDashboardStore((s) => s.totalOtHoursError);
  const otRate = useDailyOvertimeDashboardStore((s) => s.otRate);
  const otRateChangePrct = useDailyOvertimeDashboardStore((s) => s.otRateChangePrct);
  const otRateError = useDailyOvertimeDashboardStore((s) => s.otRateError);
  const priorPeriodRange = useDailyOvertimeDashboardStore((s) => s.priorPeriodRange);

  const comparisonText = priorPeriodRange
    ? `vs. ${formatPayPeriodRangeLabel(priorPeriodRange, i18n.language)}`
    : undefined;

  const totalOtHoursCard = totalOtHoursError
    ? buildErrorCard('Total Overtime Hours')
    : buildValueCard(
        'Total Overtime Hours',
        formatDashboardNumber(totalOtHours),
        totalOtHoursChangePrct,
        comparisonText,
      );

  const otRateCard = otRateError
    ? buildErrorCard('Overtime Rate')
    : buildValueCard(
        'Overtime Rate',
        `${formatDashboardNumber(otRate)}%`,
        otRateChangePrct,
        comparisonText,
      );

  const cards: KpiStatCardProps[] = [totalOtHoursCard, otRateCard];

  return isSelectionCleared(locationIds, positions)
    ? cards.map((card) => buildClearedCard(card.label))
    : cards;
}
